/* eslint-disable @typescript-eslint/no-unused-vars */
import { LiveHeaderChips } from "../../components/live/LiveCounters";   // tog'a #3203
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/auth/AuthContext";
import { Layout, Typography, Tooltip, Button } from "antd";
import { TitleContext } from "../../contexts/TitleContext";
import { Settings } from "react-feather";
import { useTranslation } from "react-i18next";
import Modal from "../../components/modal";
import SettingsModal from "../../components/modal/settings/SettingsModal";
import useQueryParams from "../../hooks/useQueryParams";
import AddAdminForm from "../../components/form/AddAdminForm";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import "./Header.less";
import LogoutButton from "../../components/button/LogoutButton";
import NotificationsBell from "../../components/notifications/NotificationsBell";
import SubscriptionBattery from "../../components/SubscriptionBattery";   // Boshliq (2026-09-05)
import ChatBell from "../../components/chat/ChatBell";
import UserChip from "../../components/user/UserChip";
import LangSwitcher from "../../components/LangSwitcher";
import ThemeToggleButton from "../../components/button/ThemeToggleButton";
import GlobalHeaderTools from "../../components/layout/GlobalHeaderTools";   // tog'a #3353

export default function Header2(props: any) {
  const { title } = useContext(TitleContext);
  const { lg, xl } = useBreakpoint();
  const telefonUI = xl === false;   // tog'a #3353: telefon va planshet (< 1200) — birinchi render'da {} → kompyuter ko'rinishi
  const { authState } = useContext(AuthContext);
  const query = useQueryParams();
  const { t } = useTranslation();
  // tog'a 1114/1117 (2026-09-04): jadval sahifalari O'Z sarlavhasini chizadi (Header.tsx) — bu umumiy sarlavha
  // avval uning OSTIDA (bir xil geometriya) yashirinib turardi. iPad'da (qorong'i rejim, tor ekran) balandliklar
  // farq qilib IKKALASI ketma-ket ko'rinib qoldi. Endi sahifada boshqa sarlavha bo'lsa — bu sarlavha chizilmaydi.
  const [hasPageHeader, setHasPageHeader] = useState(false);
  useEffect(() => {
    let raf = 0;
    const check = () => {
      raf = 0;
      const n = document.querySelectorAll(".site-layout-header:not(.site-layout-header--home)").length;
      setHasPageHeader(n > 0);
    };
    const schedule = () => { if (!raf) raf = window.requestAnimationFrame(check); };
    check();
    const mo = new MutationObserver(schedule);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { mo.disconnect(); if (raf) window.cancelAnimationFrame(raf); };
  }, []);
  if (hasPageHeader) return null;
  return (
    <Layout.Header className="site-layout-header site-layout-header--home">
      <Typography.Title
        className="TitkeHeader_r"
        style={{ margin: 0 }}
        level={4}
      >
        {title ? t(title) || title : ""}
      </Typography.Title>
      {/* <input  type="text" /> */}
      <div className="HeaderWrapper_r">
        {/* tog'a #3353 (2026-10-04): telefonda (xs) faqat 💬 🔔 «⋯» — qolganlari «⋯» ichida; kompyuterda — avvalgidek */}
        {telefonUI ? <GlobalHeaderTools onSettings={() => query.set("settings", "open")} /> : (<>
        <LiveHeaderChips />{/* tog'a #3203 (C) */}
        <UserChip />
        <ChatBell />
        <SubscriptionBattery />
        <NotificationsBell />
        {/* Egasi (2026-08-31): tillar bildirishnomalar YONIDA — RU/UZ/EN */}
        <LangSwitcher />
        <ThemeToggleButton />
        <Tooltip placement="bottom" title={t("settings")}>
          <Button
            size="large"
            className="buttonHeader_r headermargin_r"
            onClick={() => query.set("settings", "open")}
            icon={<Settings />}
          ></Button>
        </Tooltip>

        <LogoutButton />
        </>)}
      </div>
      {/* <div className="HeaderWrapper_r">
        <div className="HeaderWrapper_56" style={{width:"60%"}}>
           {props.filterComponent
          ? [...leftButtons, ...(props.tableProps?.leftButtons || [])]
          : [...(props.tableProps?.leftButtons || [])]}
        </div>
       
        {!props.hideExport && (
          <>
            <Button
              size="large"
              className="buttonHeader_r"
              icon={<Download color="currentColor" />}
              onClick={() =>
                props.handleActionButtonClick(props.TableActions.EXPORT)
              }
            >
              {lg && t("export")}
            </Button>
            <ExportOptionsModal
              onCancel={() => props.setExportModal(false)}
              visible={props.exportModal}
              onOk={props.handleExport}
            />
          </>
        )}
        
        {!props.hideAdd && (
          <Button
            size="large"
            className="buttonHeader_r"
            icon={<Plus color="currentColor" />}
            onClick={() =>
              props.handleActionButtonClick(props.TableActions.ADD)
            }
          >
            {lg && t("add")}
          </Button>
        )}
        {!props.hideDelete && (
          <Popconfirm
            placement="left"
            title={t("deleteConfirmTitle")}
            okText={t("yes")}
            cancelText={t("no")}
            onConfirm={() =>
              props.handleActionButtonClick(props.TableActions.DELETE)
            }
            onCancel={() => message.warn(t("canceled"))}
          >
            <Button
              size="large"
              loading={props.cLoading}
              danger={!!props.cError}
              className="buttonHeader_r"
              icon={<Trash color="currentColor" />}
            >
              {lg && t("delete")}
            </Button>
          </Popconfirm>
        )}
        {!props.hideImport && (
          <>
            <Button
              size="large"
              className="buttonHeader_r"
              icon={<Upload color="currentColor" />}
              onClick={() =>
                props.handleActionButtonClick(props.TableActions.IMPORT)
              }
            >
              {lg && t("import")}
            </Button>
            {props.sampleData && (
              <UploadExcelModal
                onOk={props.handleImport}
                visible={props.importModal}
                sampleDate={proimport { Space } from 'antd';
ps.sampleData}import LogoutButton from './../../components/button/LogoutButton';
import { Settings } from 'react-feather';

                onCancel={() => props.setImportModal(false)}
              />
            )}
          </>
        )}
      </div> */}

      {/* <FactorySelect
        hasEmpty
        key="factory"
        onChange={(val: any) => query.set("factoryId", val.toString())}
        defaultValue={+query.secureGet("factoryId") || ""}
      /> */}

      {/* <Space size={lg ? 20 : 10} className="header-actions">
        {hasPermission(authState.user) && (
          <Button
            onClick={() => query.set("add-admin", "true")}
            type="text"
            shape="circle"
          >
            <UserPlus color="currentColor" />
          </Button>
        )}
        <Button
          className="buttonHeader_r"
          // onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Upload color="currentColor" />
          <strong>{t("export")}</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Download color="currentColor" />
          <strong>{t("import")}</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Plus color="currentColor" />
          <strong>{t("willAdd")}</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Trash color="currentColor" />
          <strong>{t("willDelete")}</strong>
        </Button>
        // <Button
        //   className="buttonHeader_r"
        //   onClick={() => query.set("settings", "open")}
        //   type="text"
        //   shape="circle"
        // >
        //   <Settings color="currentColor" />
        // </Button>

        <LogoutButton />
      </Space> */}
      <Modal footer={null} matcher="settings">
        <SettingsModal />
      </Modal>
      <Modal title={t("addAdmin")} footer={null} matcher="add-admin">
        <AddAdminForm />
      </Modal>
    </Layout.Header>
  );
}
